// extracted by mini-css-extract-plugin
export default {"advertDetailContacts":"c-n_eT","advertDetailContacts__header":"c-n_eU"};